import { Fragment } from 'react';

import { Button, ButtonContainer, Total } from 'libs/ui';
import { Sum } from './blocks/sum';
import { Content, Left } from './table-info.styled';

export const TableInfo = (props) => {
  const { count, actions, theme, summ, ...rest } = props;
  const actionsEl = actions.map((el, idx) => {
    const { action, icon, title, cmp, ...rest } = el;
    if (cmp) {
      return <Fragment key={idx}>{cmp}</Fragment>;
    }
    return (
      <Button key={idx} onClick={action} {...rest}>
        <i className={'fa ' + icon} />
        {title}
      </Button>
    );
  });

  const other = { cnt: count, theme, ...rest };

  return (
    <Content>
      <Left>
        <Total {...other} />
        {!!summ && <Sum value={summ} />}
      </Left>
      <ButtonContainer>{actionsEl}</ButtonContainer>
    </Content>
  );
};
